import * as types from './actionTypes';
import {apiPost, apiRequest} from '../utils/request';
import {toastr} from 'react-redux-toastr';
import { getErrorMessage, requestHasError } from '../utils/lib';

export function listCompanyFilesSuccess({items}){
  return {type: types.LIST_COMPANY_FILES_SUCCESS, items};
}

export function clearCompanyFilesSuccess(){
  return {type: types.CLEAR_COMPANY_FILES_SUCCESS, items: []};
}

export function listCompanyFiles() {
  return function (dispatch) {
    return apiRequest(`/api/rebatercti/company-file`)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Error while fetching rebates RCTI, error: ${getErrorMessage({x})}`);
          dispatch(clearCompanyFilesSuccess());
        } else {
          dispatch(listCompanyFilesSuccess({items: {...x.data}}));
        }
        return x;
      });
  };
}

export function clearCompanyFiles() {
  return function (dispatch) {
    return dispatch(clearCompanyFilesSuccess());
  };
}

export function getMyobRedirectionUrl({returnUrl}) {
    return function (dispatch) {
      return apiRequest(`/api/rebatercti/auth-url?returnUrl=${returnUrl}`)
        .then(x => {
          if (requestHasError({x})) {
            toastr.error(`Error while fetching MYOB redirection url, error: ${getErrorMessage({x})}`);
          } 
          return x;
        });
    };
  }

  export function updateCompanyFiles({payLoad}) {
    return function (dispatch) {
      return apiPost(`/api/rebatercti/setting`, payLoad)
        .then(x => {
          if (requestHasError({x})) {
            toastr.error(`Error updating myob configuration, error: ${getErrorMessage({x})}`);
          } 
          return x;
        });
    };
  }
